const Modal = (): JSX.Element => {
  return (
    <div className="modal-body">
      <p>
        Označení Terroir Čejkovice je možné přiznávat pouze vínům vyrobených z
        odrůd:
      </p>
      <p className="fw-bold"> Rulandské modré a Tramín.</p>
      <p className="mb-3">
        {' '}
        Vína mohou být vyráběna pouze členy sdružení Čtvrtečníci - sdružení
        vinařů Čejkovice, z.s.
      </p>
      <p className="mb-3">
        Vína musí být vyráběna pouze z hroznů vypěstovaných na registrovaných
        vinicích v katastru obce Čejkovice s minimálním počtem 4.500 keřů na
        hektar. Hrozny musí být zdravé. Víno by mělo být ve větší míře formované
        vinohradem = terroir. Výnos u odrůdy Rulandské modré nesmí překročit 1,5
        kg hroznů na keř a výnos u odrůdy Tramín nesmí překročit 2 kg hroznů na
        keř.
      </p>
      <p className="mb-3">
        Hrozny musí být zpracovány bez exogenních enzymů a jiných maceračních
        přídavných látek. Důležitá je minimalizace síření při výrobě vína. U
        odrůdy Rulandské modré je povolena maximální hranice do 100 mg/l
        veškerého SO 2. U odrůdy Tramín je povolena maximální hranice do 120
        mg/l veškerého SO 2. Není povolen přídavek kyseliny askorbové.
      </p>
      <p className="mb-3">
        Vína lze vyrábět pouze z hroznů révy vinné odpovídajících kvalitativnímu
        zařazení: víno s přívlastkem pozdní sběr a víno s přívlastkem výběr z
        hroznů. Obsah alkoholu ve vínech musí být minimálně 12,5 % obj. Vína by
        měla být plná a extraktivní a musí vykazovat typické senzorické
        vlastnosti dané odrůdy.
      </p>
      <p className="mb-3">
        Vína musí být plněna do skleněných lahví o obsahu 0,75 l nebo 1,5 l. Do
        degustační komise mohou být přihlášena pouze nalahvovaná vína. Prodej
        vín je povolen od 1. 5. každého kalendářního roku při splnění
        minimálních dob zrání vín. Po schválení vína degustační komisí budou
        láhve označovány kolkem Terroir Čejkovice nalepeným kolem hrdla lahve.
      </p>
      <p className="mb-3">
        Degustace probíhá minimálně jednou ročně. Degustační komise je složena
        ze členů spolku Čtvrtečníci - sdružení vinařů Čejkovice a z pozvaných
        hostů. Pracuje v minimálním počtu 11 osob.
      </p>
      <p className="mb-3">
        Degustační komise hodnotí vína body a také o vínech hlasuje. Víno je
        hodnoceno stobodovým systémem mezinárodní unie enologů, ale hodnotí se
        pouze body „po pěti“ např.: 85, 90, 95 a 100. Minimální bodové
        ohodnocení pro zařazení do Terroir Čejkovice je 85 bodů. Pokud je vínu
        uděleno méně jak 80 bodů musí být napsáno odůvodnění. Dále je o víně
        hlasováno, přičemž pro zařazení do Terroir Čejkovice je nutný souhlas
        2/3 hodnotících členů degustační komise.
      </p>
      <h5 className="mb-4">
        Senzorické vlastnosti a technologické požadavky pro jednotlivé odrůdy:
      </h5>{' '}
      <h5 className="mb-2">RULANDSKÉ MODRÉ </h5>
      <h6 className="fst-italic mb-4">
        Typické rulandové, odrůdové, komplexní s jemným projevem po zrání v
        sudu.
      </h6>{' '}
      <div className="mb-5">
        <p className="mb-3">
          Víno musí mít obsah zbytkového cukru (fruktóza + glukóza) maximálně 4
          g/l.
        </p>
        <p className="mb-3">
          Víno musí mít obsah alkoholu minimálně 12,5 % obj.
        </p>
        <p className="mb-3">víno musí zrát minimálně 12 měsíců v sudech.</p>
        <p className="mb-3">musí být provedena jablečno-mléčná fermentace.</p>
        <p className="mb-3">
          Víno musí zrát na jemných kalech minimálně 120 dní od konce fermentace
          nebo 150 dní od sklizně.
        </p>
        <p className="mb-3">
          Prodej vín je možný nejdříve po 19 měsících od 1. října roku sklizně
          hroznů.
        </p>
        <p className="mb-3">
          Při využití nových vypalovaných sudů pro maximálně 33 % celkového
          objemu vína, je uvedení vín na trh pod označením Terroir Čejkovice
          možné nejdříve po 19 měsících od 1. října roku sklizně hroznů.
        </p>
        <p className="mb-3">
          Při využití nových vypalovaných sudů pro více než 33 % celkového
          objemu vína, je uvedení vín na trh pod označením Terroir Čejkovice
          možné nejdříve po 31 měsících od 1. října roku sklizně hroznů.
        </p>
      </div>
      <h5>TRAMÍN</h5>
      <h6 className="fst-italic mb-4">Hutné, harmonické a kořenité víno</h6>
      <div className="mb-5">
        <p className="mb-3">
          Víno musí mít obsah zbytkového cukru (fruktóza + glukóza) maximálně 4
          g/l.
        </p>
        <p className="mb-3">
          Víno musí mít obsah alkoholu minimálně 12,5 % obj.
        </p>
        <p className="mb-3">Víno musí zrát minimálně 9 měsíců.</p>
        <p className="mb-3">Hrozny musí být macerovány minimálně 24 hodin.</p>
        <p className="mb-3">
          Není povolena výroba technologií „oranžových vín“.
        </p>
        <p className="mb-3">
          Víno musí zrát na jemných kalech minimálně 120 dní od konce fermentace
          nebo 150 dní od sklizně.
        </p>{' '}
        <p className="mb-3">
          Prodej vín je možný nejdříve po 19 měsících od 1. října roku sklizně
          hroznů.
        </p>
        <p className="mb-3">
          Při využití nových vypalovaných sudů pro maximálně 33 % celkového
          objemu vína, je uvedení vín na trh pod označením Terroir Čejkovice
          možné nejdříve po 19 měsících od 1. října roku sklizně hroznů.
        </p>
        <p className="mb-3">
          Při využití nových vypalovaných sudů pro více než 33 % celkového
          objemu vína, je uvedení vín na trh pod označením Terroir Čejkovice
          možné nejdříve po 31 měsících od 1. října roku sklizně hroznů.
        </p>
      </div>
      <h5> Závěrečné ustanovení </h5> Autor statutu Terroir Čejkovice -
      Čtvrtečníci - sdružení vinařů Čejkovice, z.s. si vyhrazuje právo, jako
      jediný subjekt, upravovat tento statut a to po projednání v pracovní
      skupině a následném odsouhlasení členskou schůzí spolku.
    </div>
  );
};

export default Modal;
